"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelTabs = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
require("./index.scss");
const className = 'panel-tabs';
const PanelTabs = (props) => {
    const { selectedTabId, selectTab, modificators } = props;
    const tabs = (0, react_1.useMemo)(() => props.tabs.filter(x => !x.hidden), [props.tabs]);
    const selectedTab = tabs.find(tab => tab.id === selectedTabId);
    if (!tabs.length)
        return null;
    return (react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(className, modificators) },
        react_1.default.createElement("div", { className: `${className}__tabs` }, tabs.map(tab => (react_1.default.createElement("button", { key: tab.id, type: 'button', className: (0, classFunctions_1.getClassNames)(`${className}__tab-button`, [
                selectedTabId === tab.id ? 'active' : undefined,
            ]), onClick: () => selectTab(tab.id) }, tab.label)))),
        selectedTab && react_1.default.createElement(selectedTab.Panel, null)));
};
exports.PanelTabs = PanelTabs;
//# sourceMappingURL=index.js.map